import {Box, Paper, Stack, Typography} from "@mui/material";
import PieChartUI from "./components/pie-chart-ui";
import {useGetSolvesInfoQuery} from "../../store/api/problemsetApiSlice";

export default function TotalProblemPieChart() {
  const {data} = useGetSolvesInfoQuery();

  return (
    <Paper variant="feature" sx={{p: "20px"}}>
      <Typography fontSize={"1rem"} fontWeight={700}>
        TOTAL SOLVES
      </Typography>
      <Typography component="p" variant="subtitle2" fontWeight="light">
        Solve more, learn faster, grow stronger.
      </Typography>
      <Box sx={{height: "16px"}} />
      <Stack width={"100%"}>
        <PieChartUI value={data} />
      </Stack>
    </Paper>
  );
}
